import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

// Helper function to format currency
const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

// Helper function to format date
const formatDate = (dateString) => {
  if (!dateString) return 'N/D';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR').format(date);
};

function ReportsPage() {
  const [reportsData, setReportsData] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const fetchReports = useCallback(() => {
    api.get('/reports', {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    })
      .then(response => {
        setReportsData(response.data);
      })
      .catch(error => {
        console.error('Houve um erro ao buscar os relatórios!', error);
      });
  }, [startDate, endDate]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  if (!reportsData) {
    return <div>Carregando Relatórios...</div>;
  }

  return (
    <div>
      <h1>Relatórios</h1>

      <div className="mb-3">
        <label htmlFor="startDate" className="form-label">Data de Início</label>
        <input type="date" className="form-control" id="startDate" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
      </div>
      <div className="mb-3">
        <label htmlFor="endDate" className="form-label">Data de Fim</label>
        <input type="date" className="form-control" id="endDate" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      </div>
      <button className="btn btn-primary mb-3" onClick={fetchReports}>Gerar Relatórios</button>

      {/* Revenue Report */}
      <div className="card mb-3">
        <div className="card-header">Relatório de Receitas</div>
        <div className="card-body">
          <p>Total de Receitas: {formatCurrency(reportsData.relatorio_receitas.total_receitas)}</p>
          <h5>Receitas por Categoria:</h5>
          <ul>
            {reportsData.relatorio_receitas.por_categoria.map((item, index) => (
              <li key={index}>{item.category_name}: {formatCurrency(item.total_amount)}</li>
            ))}
          </ul>
          <h5>Receitas por Cliente:</h5>
          <ul>
            {reportsData.relatorio_receitas.por_cliente.map((item, index) => (
              <li key={index}>{item.customer_name}: {formatCurrency(item.total_amount)}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Expense Report */}
      <div className="card mb-3">
        <div className="card-header">Relatório de Despesas</div>
        <div className="card-body">
          <p>Total de Despesas: {formatCurrency(reportsData.relatorio_despesas.total_despesas)}</p>
          <h5>Despesas por Categoria:</h5>
          <ul>
            {reportsData.relatorio_despesas.por_categoria.map((item, index) => (
              <li key={index}>{item.category_name}: {formatCurrency(item.total_amount)}</li>
            ))}
          </ul>
          <h5>Despesas por Fornecedor:</h5>
          <ul>
            {reportsData.relatorio_despesas.por_fornecedor.map((item, index) => (
              <li key={index}>{item.provider_name}: {formatCurrency(item.total_amount)}</li>
            ))}
          </ul>
          <h5>Despesas por Forma de Pagamento:</h5>
          <ul>
            {reportsData.relatorio_despesas.por_forma_pagamento.map((item, index) => (
              <li key={index}>{item.payment_method}: {formatCurrency(item.total_amount)}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Result Report */}
      <div className="card mb-3">
        <div className="card-header">Relatório de Resultado</div>
        <div className="card-body">
          <p>Resultado Líquido: {formatCurrency(reportsData.relatorio_resultado.resultado_liquido)}</p>
        </div>
      </div>

      {/* Credit Card Usage Report */}
      <div className="card mb-3">
        <div className="card-header">Relatório de Uso de Cartão de Crédito</div>
        <div className="card-body">
          {reportsData.relatorio_uso_cartao_credito.map(card => (
            <div key={card.nome_cartao} className="mb-2">
              <h6>{card.nome_cartao}</h6>
              <p>Total Gasto: {formatCurrency(card.total_gasto)}</p>
              <p>Percentual Utilizado: {card.percentual_usado.toFixed(2)}%</p>
              {/* Invoice history can be displayed in a more detailed view */}
            </div>
          ))}
        </div>
      </div>

      {/* Accounts Status Report */}
      <div className="card mb-3">
        <div className="card-header">Relatório de Status das Contas</div>
        <div className="card-body">
          <h5>Contas Atrasadas:</h5>
          <ul>
            {reportsData.relatorio_status_contas.contas_atrasadas.map(account => (
              <li key={account.id}>{account.description} - {formatCurrency(account.amount)} (Vencimento: {formatDate(account.due_date)})</li>
            ))}
          </ul>
          <h5>Contas Próximas:</h5>
          <ul>
            {reportsData.relatorio_status_contas.contas_proximas.map(account => (
              <li key={account.id}>{account.description} - {formatCurrency(account.amount)} (Vencimento: {formatDate(account.due_date)})</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ReportsPage;
